export const colors = {
  primaryBannerBlue: '#1E2742',
  racineRedDark: '#872635',
  racineRedLight: '#BC2534',
  primaryApplicationText: '#1E2742',
};
